'use client';
import { jsx as s } from "react/jsx-runtime";
import { useState as o, useEffect as A } from "react";
import { SkeletonItem as D, SkeletonAnimationType as E } from "@gs-ux-uitoolkit-react/skeleton";
import { formatForRequest as F } from "./index.es3.js";
import { getInterestDetailsForTag as S } from "./index.es4.js";
import T from "./index.es5.js";
const O = ({ followItem: t, targetId: a, withDropdown: i = !0, className: l }) => {
  const e = "tagGuid" in t, [c, r] = o(e), f = e ? {
    followActive: !1,
    alertActive: !1,
    distributionChannels: [],
    includeAlerts: []
  } : t, [m, u] = o(f), [d, p] = o(!1), g = (n) => {
    p(n), r(!1);
  };
  return A(() => {
    e && (async () => {
      const y = typeof t == "string" ? JSON.parse(t) : t, I = F(y), h = await S([I], g);
      u(h[0] || {}), r(!1);
    })();
  }, [t, e]), c ? /* @__PURE__ */ s(D, { animation: E.Pulse, size: "md", shape: "square" }) : /* @__PURE__ */ s("div", { className: l, children: /* @__PURE__ */ s(T, { followItem: m, targetId: a, withDropdown: i, isError: d }) });
};
export {
  O as default
};
//# sourceMappingURL=index.es.js.map
